baseRange